<template>
    <div>
        <div class="vx-col w-full mb-base">
            <vs-card class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" ></vs-button>
                        <h4 style="margin-left: 10px">Setting</h4>
                    </div>
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1">Save</vs-button>
                </div>
                <div class="vx-row mt-6">
                    <vs-tabs position="left" v-if="ready">
                        <vs-tab v-for="(group, index) in data" :key="index" :label="group.name" icon-pack="feather" :icon="group.icon" class="asd">
                            <div class="vx-row w-full">
                                <div class="vx-col w-full" v-for="(item, itemindex) in group.items" :key="itemindex">
                                    <div class="vx-row mb-3" v-if="!item.options">
                                        <div class="vx-col w-full">
                                            <vs-input class="w-full" label="Template Name *" v-model="item.value"/>
                                        </div>
                                    </div>
                                        <div class="vx-col w-full" v-else>
                                            <label for="" class="vs-input--label">Type</label>  
                                            <vs-select
                                                class="selectExample"
                                                v-model="item.value"
                                                width="100%"
                                                autocomplete
                                            >
                                                <vs-select-item v-for="(option, optionindex) in item.options" :key="optionindex" :value="option" :text="option"/>
                                            </vs-select>
                                        </div>
                                </div>
                            </div>
                        </vs-tab>
                    </vs-tabs>
                </div>
            </vs-card>
        </div>
    </div>
</template>

<script>
	import vSelect from 'vue-select'
	import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

	export default {
		components:{
			vSelect,
			flatPickr,
		},
		data(){
			return {
                data: [],
                ready: false
			}
        },
        watch: {
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            }
        },
        methods:{
            fetchData() {
                this.$http.get('settings')
                .then(res => {
                    let group = [];

                    res.data.map(item => {
                        if(item.options) {
                            item.options = JSON.parse(item.options);
                        }
                        
                        if(!group.length) {
                            group.push({
                                name: item.group_name,
                                icon: item.group_icon,
                                items: [item],
                            });
                        }
                        else {
                            const index = group[group.findIndex(g => g.name === item.group_name)];

                            if(index) {
                                index.items.push(item);
                            }
                            else {
                                group.push({
                                    name: item.group_name,
                                    icon: item.group_icon,
                                    items: [item],
                                });
                            }
                        }
                    });

                    this.data = group;
                    this.ready = false
                    this.$nextTick(() => {
                        this.ready = true
                    })
                })
            },
        },
        mounted(){
            this.fetchData()
        }
	}
</script>

<style scoped>
    .con-vs-tabs >>> .con-slot-tabs {
        display: flex !important;
        flex: 1 !important;
    }
</style>